class ReviewWidget extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.endpoint = 'https://beercartel.justwines.com.au/api/product-rating'; // Update with your endpoint
    this.reviews = [];
    this.averageRating = 0;
    this.totalReviews = 0;
    
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        .review-widget {
          font-family: sans-serif;
          
          margin: 20px auto;
          padding: 20px;
          border: 1px solid #ddd;
          border-radius: 8px;
        }
        .average-rating {
          font-size: 24px;
          font-weight: bold;
          margin-right: 10px;
        }
        .stars {
          color: #ffb400;
          margin-right: 10px;
        }
        .total-reviews {
          color: #666;
        }
        .review-list {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
        }
        .review-item {
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #eee;
          width: 33%;
        }
        .review-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .user-name {
          font-weight: bold;
        }
        .review-date {
          color: #666;
          font-size: 12px;
          margin-left: 10px;
        }
        .review-rating {
          color: #ffb400;
          margin: 5px 0;
        }
        .review-comment {
          margin: 10px 0;
        }
        .review-media {
          margin-top: 10px;
        }
        .review-media img {
          max-width: 50%;
          max-height: 50%;
          border-radius: 4px;
          margin-right: 10px;
        }
        .loading {
          text-align: center;
          padding: 20px;
        }
        .error {
          color: #d32f2f;
          text-align: center;
          padding: 20px;
        }
        @media(max-width: 767px){
          .review-item{
            width: 100%;
            text-align: center;
          }
        }
      </style>
      <div class="review-widget">
        
        <div class="review-list"></div>
      </div>
    `;
  }

  connectedCallback() {
    this.fetchReviews();
  }

  async fetchReviews() {
    try {
        this.showLoading();
        console.log("Fetching:", `${this.endpoint}?id=${this.productId}`);
        
        const response = await fetch(`${this.endpoint}?id=${this.productId}`);
        console.log("Response status:", response.status);
        
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log("API Data:", data);
        
        if (data.reviews.length > 0) {
            this.copyReviewsSection();
            this.reviews = data.reviews;
            this.averageRating = data.average_rating;
            this.totalReviews = data.total_reviews;
            this.renderReviews();
          
        } else {
            this.showError('No reviews to display');
            const style = document.createElement('style');
            style.innerHTML = `
              .bc_pdp_untappd_reviews {
                display: none !important;
              }
            `;
            document.head.appendChild(style);


        }
    } catch (error) {
        console.error("Fetch error:", error);
        this.showError('No reviews to display');
        const style = document.createElement('style');
        style.innerHTML = `
          .bc_pdp_untappd_reviews {
            display: none !important;
          }
        `;
        document.head.appendChild(style);


    }
}

  renderReviews() {
    const ratingSummary = this.shadowRoot.querySelector('.rating-summary');

    let totalReviewsEl = '';
                    
    if( ratingSummary ){
      const averageRatingEl = ratingSummary.querySelector('.average-rating');
      totalReviewsEl = ratingSummary.querySelector('.total-reviews');
      let starsEl = ratingSummary.querySelector('.stars');

      // Update summary
  
      averageRatingEl.textContent = this.averageRating.toFixed(1);
  
      totalReviewsEl.textContent = `Based on ${this.totalReviews} reviews`;
    }

    const reviewList = this.shadowRoot.querySelector('.review-list');

    
    // Clear existing reviews
    reviewList.innerHTML = '';
    
    // Add each review
    this.reviews.forEach(review => {
      const reviewItem = document.createElement('div');
      reviewItem.className = 'review-item';
      
      const date = new Date(review.created_at).toLocaleDateString();
      
      reviewItem.innerHTML = `
        <div class="review-header">
          <img class="user-avatar" src="${review.user.avatar}" alt="${review.user.name}">
          <div class="user-name">${review.user.name}</div>
          <div class="review-date">${date}</div>
        </div>
        <div class="review-rating">${'★'.repeat(Math.round(review.rating))}</div>
        ${review.media && review.media.length > 0 ? `
          <div class="review-media">
            ${review.media.map(media => `<img src="${media.photo_url}" alt="Review photo">`).join('')}
          </div>
        ` : ''}
        <div class="review-comment"><strong>${review.comment}</strong></div>
      `;
      
      reviewList.appendChild(reviewItem);
    });
  }

  showLoading() {
    const reviewList = this.shadowRoot.querySelector('.review-list');
    reviewList.innerHTML = '<div class="loading">Loading reviews...</div>';
  }

  showError(message) {
    const reviewList = this.shadowRoot.querySelector('.review-list');
    reviewList.innerHTML = `<div class="error">${message}</div>`;
  }

  copyReviewsSection(){

    let intervalId = setInterval(function() {
      let sourceElement = document.querySelector('.rating-container');
      let destination = document.querySelector('.untappd_rating');
    
      if (sourceElement && destination) {
        destination.innerHTML = sourceElement.innerHTML;
        clearInterval(intervalId);
      }
    }, 500);

    /* setTimeout(function() {
      let sourceHTML = document.querySelector('.rating-container')?.innerHTML;
  
      if (sourceHTML !== undefined) {
        let destination = document.querySelector('.untappd_rating');
        if (destination) {
          destination.innerHTML = sourceHTML;
        }
      }
    }, 1000); */
  }
}

// Define the custom element
if (!customElements.get('review-widget')) {
  customElements.define('review-widget', ReviewWidget);
}